import { DateTime } from 'luxon';

export type DateNumber = number;

export const getDateNumber = (dateTime?: DateTime): DateNumber => {
  if (!dateTime) {
    dateTime = DateTime.now();
  }
  return parseInt(dateTime.toFormat('yyyyLLdd')) as DateNumber;
};

export const parseDateNumber = (dateNumber: DateNumber): DateTime => {
  return DateTime.fromFormat(dateNumber.toString(), 'yyyyLLdd');
};

export const renderDateNumber = (dateNumber: DateNumber | null): string => {
  return dateNumber ? parseDateNumber(dateNumber).toLocaleString() : "";
};

export const getDateTimeFromServerTime = (serverTime: string): DateTime => {
  return DateTime.fromISO(serverTime);
}